<template>
  <div class="container py-5">
    <h1 class="mb-2">User Dashboard</h1>
    <p class="text-muted mb-4">This area will contain your bookings and profile.</p>

    <div class="card">
      <div class="card-body">
        <h5 class="card-title mb-1">Welcome</h5>
        <p class="card-text mb-0">Next step: connect to backend APIs for user data.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDashboard',
};
</script>

